import { render, staticRenderFns } from "./QRRedirect.vue?vue&type=template&id=b98324ce&"
import script from "./QRRedirect.vue?vue&type=script&lang=js&"
export * from "./QRRedirect.vue?vue&type=script&lang=js&"
import style0 from "./QRRedirect.vue?vue&type=style&index=0&id=b98324ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
